// Generated by Melange

import * as Buhta_cabinet__ErrorPage from "../../../../pages/ErrorPage.js";
import * as Buhta_cabinet__Kassa from "../../../../grpc/Kassa.js";
import * as Buhta_cabinet__Link from "../../../html/Link.js";
import * as Buhta_cabinet__ReceiptBody from "./ReceiptBody.js";
import * as Buhta_cabinet__Route from "../../../../Route.js";
import * as Buhta_components__LoadingDiv from "../../../../../../../packages/components/src/atoms/LoadingDiv.js";
import * as Buhta_components__Text from "../../../../../../../packages/components/src/html/Text.js";
import * as Buhta_core__GlobalStateContext from "../../../../../../../packages/core/lib/GlobalStateContext.js";
import * as Buhta_core__GrpcState from "../../../../../../../packages/core/lib/GrpcState.js";
import * as Buhta_core__Tenant from "../../../../../../../packages/core/lib/Tenant.js";
import * as Buhta_core__Toast from "../../../../../../../packages/core/lib/Toast.js";
import * as Cn from "../../../../../../../vendored/classnames/Cn.js";
import * as Curry from "melange.js/curry.js";
import * as StaticAsset from "../../../../../../../packages/util/lib/StaticAsset.js";
import * as React from "react";
import * as ReactCopyToClipboard from "react-copy-to-clipboard";
import * as JsxRuntime from "react/jsx-runtime";

function Receipt(Props) {
  let onMaximize = Props.onMaximize;
  let maximizeReceipt = Props.maximizeReceipt;
  let kkm = Props.kkm;
  let orgId = Props.orgId;
  let idOpt = Props.id;
  let onCloseOpt = Props.onClose;
  const id = idOpt !== undefined ? idOpt : "";
  const onClose = onCloseOpt !== undefined ? onCloseOpt : (function (param) {
      
    });
  const state = Buhta_core__GlobalStateContext.useGlobalState(undefined);
  const deviceType = state.deviceType;
  const match = Buhta_core__Toast.ToastsContext.useToasts(undefined);
  const dispatchToasts = match[1];
  const currentRoute = Buhta_cabinet__Route.ofUrl(Buhta_cabinet__Route.useClientUrl(undefined));
  const match$1 = Buhta_core__Tenant.useTenant(undefined);
  const tenant = match$1[0];
  const contextRoute = function (route) {
    return Buhta_cabinet__Route.contextRoute(tenant.ctx, orgId, route);
  };
  let receiptId;
  if (/* tag */ typeof currentRoute === "number" || typeof currentRoute === "string") {
    receiptId = id;
  } else {
    switch (currentRoute.TAG) {
      case /* Org */ 6 :
        const match$2 = currentRoute._1;
        if (/* tag */ typeof match$2 === "number" || typeof match$2 === "string" || match$2.TAG !== /* Kassa */ 2) {
          receiptId = id;
        } else {
          const match$3 = match$2._0._0;
          if (/* tag */ typeof match$3 === "number" || typeof match$3 === "string") {
            receiptId = id;
          } else {
            const match$4 = match$3._1;
            if (/* tag */ typeof match$4 === "number" || typeof match$4 === "string" || match$4.TAG !== /* Receipts */ 1) {
              receiptId = id;
            } else {
              const id$1 = match$4._0;
              receiptId = /* tag */ typeof id$1 === "number" || typeof id$1 === "string" || id$1.TAG !== /* View */ 0 ? id : id$1._0;
            }
          }
        }
        break;
      case /* Admin */ 7 :
        const match$5 = currentRoute._0;
        if (/* tag */ typeof match$5 === "number" || typeof match$5 === "string" || match$5.TAG !== /* Orgs */ 1) {
          receiptId = id;
        } else {
          const match$6 = match$5._0;
          if (/* tag */ typeof match$6 === "number" || typeof match$6 === "string") {
            receiptId = id;
          } else {
            const match$7 = match$6._1;
            if (/* tag */ typeof match$7 === "number" || typeof match$7 === "string" || match$7.TAG !== /* Kassa */ 2) {
              receiptId = id;
            } else {
              const match$8 = match$7._0._0;
              if (/* tag */ typeof match$8 === "number" || typeof match$8 === "string") {
                receiptId = id;
              } else {
                const match$9 = match$8._1;
                if (/* tag */ typeof match$9 === "number" || typeof match$9 === "string" || match$9.TAG !== /* Receipts */ 1) {
                  receiptId = id;
                } else {
                  const id$2 = match$9._0;
                  receiptId = /* tag */ typeof id$2 === "number" || typeof id$2 === "string" || id$2.TAG !== /* View */ 0 ? id : id$2._0;
                }
              }
            }
          }
        }
        break;
      default:
        receiptId = id;
    }
  }
  const func = Buhta_cabinet__Kassa.ReceiptService.view;
  const match$10 = Buhta_core__GrpcState.useModel((function (param) {
    return Curry._4(func, param, kkm, /* [] */ 0, receiptId);
  }), undefined);
  const dispatch = match$10[1];
  const receipt = match$10[0];
  React.useEffect((function () {
    if (receiptId !== "") {
      Curry._2(dispatch, undefined, undefined);
    }
    
  }), [
    kkm,
    receiptId
  ]);
  let tmp;
  if (typeof receipt === "string") {
    tmp = JsxRuntime.jsx(Buhta_components__LoadingDiv.make, {});
  } else if (receipt.NAME === "Data") {
    const rcp = receipt.VAL;
    tmp = JsxRuntime.jsxs(React.Fragment, {
      children: [
        deviceType === "mobile" ? null : JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsxs("div", {
                children: [
                  id === "" ? JsxRuntime.jsx(Buhta_cabinet__Link.make, {
                      route: contextRoute({
                        TAG: /* Kassa */ 2,
                        _0: {
                          TAG: /* Kkms */ 0,
                          _0: {
                            TAG: /* Kkm */ 0,
                            _0: kkm,
                            _1: {
                              TAG: /* Receipts */ 1,
                              _0: /* List */ 0
                            }
                          }
                        }
                      }),
                      onLinkClicked: (function (param) {
                        Curry._1(onMaximize, false);
                      }),
                      children: JsxRuntime.jsx("img", {
                        className: "w-5 h-5",
                        src: StaticAsset.src("/static/icons/close-20.svg")
                      })
                    }) : JsxRuntime.jsx("button", {
                      children: JsxRuntime.jsx("img", {
                        className: "w-5 h-5",
                        src: StaticAsset.src("/static/icons/close-20.svg")
                      }),
                      onClick: (function (param) {
                        Curry._1(onMaximize, false);
                        Curry._1(onClose, undefined);
                      })
                    }),
                  JsxRuntime.jsx(Buhta_components__Text.H3.make, {
                    className: "ml-4",
                    children: "Чек №" + String(rcp.serial_id)
                  })
                ],
                className: "flex items-center"
              }),
              JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx("button", {
                    children: maximizeReceipt ? JsxRuntime.jsx("img", {
                        className: "w-5 h-5",
                        src: StaticAsset.src("/static/icons/minimize.svg")
                      }) : JsxRuntime.jsx("img", {
                        className: "w-5 h-5",
                        src: StaticAsset.src("/static/icons/maximize.svg")
                      }),
                    onClick: (function (param) {
                      Curry._1(onMaximize, !maximizeReceipt);
                    })
                  }),
                  JsxRuntime.jsx(ReactCopyToClipboard.CopyToClipboard, {
                    text: window.location.protocol + ("//" + (window.location.host + ("/receipt/" + (String(kkm) + ("/" + rcp.id))))),
                    onCopy: (function (param) {
                      Curry._1(dispatchToasts, {
                        TAG: /* Add */ 0,
                        _0: {
                          id: Buhta_core__Toast.generateId(undefined),
                          text: "Ссылка скопирована",
                          kind: "success",
                          onClick: (function (param) {
                            
                          })
                        }
                      });
                    }),
                    children: JsxRuntime.jsx("img", {
                      className: "ml-4 w-5 h-5 cursor-pointer",
                      src: StaticAsset.src("/static/icons/link.svg")
                    })
                  }),
                  JsxRuntime.jsx("a", {
                    children: JsxRuntime.jsx("img", {
                      className: "ml-4 w-5 h-5",
                      src: StaticAsset.src("/static/icons/share.svg")
                    }),
                    href: "/receipt/" + (String(kkm) + ("/" + rcp.id)),
                    target: "_blank"
                  })
                ],
                className: "flex items-center"
              })
            ],
            className: "py-4 px-6 flex items-center justify-between border-b border-gray-main"
          }),
        JsxRuntime.jsx("div", {
          children: JsxRuntime.jsx("div", {
            children: JsxRuntime.jsx(Buhta_cabinet__ReceiptBody.make, {
              receipt: rcp
            }),
            className: Cn.on("lg:w-122", maximizeReceipt)
          }),
          className: Cn.$plus("px-4 py-6 lg:p-6 overflow-y-auto", Cn.on("flex justify-center", maximizeReceipt))
        })
      ]
    });
  } else {
    console.log(receipt.VAL);
    tmp = JsxRuntime.jsx(Buhta_cabinet__ErrorPage.make, {});
  }
  return JsxRuntime.jsx("div", {
    children: tmp,
    className: Cn.$plus(Cn.$plus("border-l border-gray-main shrink-0 flex flex-col", Cn.on("w-full lg:w-122", !maximizeReceipt)), Cn.on("w-full", maximizeReceipt))
  });
}

const make = Receipt;

export {
  make,
}
/* Buhta_cabinet__ErrorPage Not a pure module */
